import languages from '../../i18n/utils/languages';
export class LagName {
    private lag = languages.getDefault();
    public countryList: any;

    public getLagName(name: string) {
        let lagName = '';
        switch (this.lag) {
            case "zh-CN":
                lagName = name + "_name_ch";
                break;
            case "zh-TW":
                lagName = name + "_name_tw";
                break;
            case "en-US":
                lagName = name + "_name_en";
                break;
            default:
                break;
        }
        return lagName ? lagName : name + "_name_" + this.lag.split("-")[1].toLowerCase();
    }
}

export default new LagName();
